module.exports = __webpack_public_path__ + "img/no-data.8b54278f.png";